'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./slider.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Slider(_ref) {
  var min = _ref.min,
      value = _ref.value,
      max = _ref.max,
      step = _ref.step,
      pin = _ref.pin,
      label = _ref.label,
      topLabel = _ref.topLabel,
      handleChange = _ref.handleChange,
      style = _ref.style,
      onChange = _ref.onChange,
      valueTemplate = _ref.valueTemplate;

  var currentValue = value;

  if (currentValue < 0) {
    console.warn('The Slider component needs to have value >= 0');

    return null;
  }

  if (min && currentValue < min) {
    currentValue = min;
  }

  if (max && currentValue > max) {
    currentValue = max;
  }

  if (handleChange) {
    console.warn('Slider - handleChange property will be deprecated in the next version, please change it to onChange');
  }
  var change = onChange || handleChange;

  var width = (currentValue - min) / (max - min) * 100;
  var pinwidth = (pin - min) / (max - min) * 100;
  var minValue = valueTemplate ? valueTemplate(min) : min;
  var maxValue = valueTemplate ? valueTemplate(max) : max;
  var knobValue = valueTemplate ? valueTemplate(currentValue) : currentValue;
  var hasLabel = !!(label || valueTemplate);
  var topLabelClasses = (0, _classnames2.default)('slider__value-top', width === 0 && 'slider__value--start', width === 100 && 'slider__value--end');

  var pinValueClasses = (0, _classnames2.default)('slider__value slider__labels', pinwidth === 0 && 'slider__value--start', pinwidth === 100 && 'slider__value--end');

  var sliderBarClasses = (0, _classnames2.default)('slider__bar', pin && pin < value && 'slider__bar--upgrade');

  var sliderPiClasses = (0, _classnames2.default)('slider__pin', pin && pin < value && 'slider__pin--upgrade');

  var styleProp = style ? { style: style } : null;

  return _react2.default.createElement(
    'div',
    _extends({ className: 'slider' }, styleProp),
    hasLabel && !topLabel && _react2.default.createElement(
      'p',
      { style: { left: width + '%' }, className: topLabelClasses },
      knobValue,
      ' ',
      label
    ),
    hasLabel && topLabel && _react2.default.createElement(
      'p',
      { style: { left: width + '%' }, className: topLabelClasses },
      knobValue,
      ' ',
      label,
      ' ',
      _react2.default.createElement(
        'span',
        { className: 'slider__labels--light' },
        '(',
        topLabel,
        ')'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'slider__controls' },
      _react2.default.createElement('input', {
        type: 'range',
        className: 'slider__input',
        min: min,
        value: currentValue,
        max: max,
        step: step,
        onChange: change
      }),
      pin && _react2.default.createElement('div', { className: sliderPiClasses, style: { width: pinwidth + '%' } }),
      _react2.default.createElement(
        'div',
        { className: sliderBarClasses, style: { width: width + '%' } },
        _react2.default.createElement('div', { className: 'slider__knob' })
      )
    ),
    pin && pin !== value && _react2.default.createElement(
      'p',
      { style: { left: pinwidth + '%' }, className: pinValueClasses },
      pin,
      ' ',
      label
    ),
    hasLabel && _react2.default.createElement(
      'div',
      { className: 'slider__labels' },
      _react2.default.createElement(
        'span',
        null,
        minValue,
        ' ',
        label
      ),
      _react2.default.createElement(
        'span',
        null,
        maxValue,
        ' ',
        label
      )
    )
  );
}

Slider.propTypes = {
  min: _propTypes2.default.number,
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  max: _propTypes2.default.number,
  step: _propTypes2.default.number,
  pin: _propTypes2.default.number,
  label: _propTypes2.default.string,
  topLabel: _propTypes2.default.node,
  valueTemplate: _propTypes2.default.func,
  handleChange: _propTypes2.default.func,
  style: _propTypes2.default.object,
  onChange: _propTypes2.default.func
};

Slider.defaultProps = {
  min: 0,
  value: 0,
  max: 10,
  step: 1
};

exports.default = Slider;